export enum ChartTheme {
  Light = 'Light',
  Dark = 'Dark',
  HighContrast = 'HighContrast',
  Default = Light,
}
